import { useNavigate } from 'react-router-dom';
import PublicLegalPage from '@/components/PublicLegalPage';
import { PRIVACY_PAGE_CONTENT, PUBLIC_CORE_LINK_LABELS } from '../../ui-foundation';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <PublicLegalPage
      title={PRIVACY_PAGE_CONTENT.title}
      subtitle={PRIVACY_PAGE_CONTENT.subtitle}
      introBody={PRIVACY_PAGE_CONTENT.introBody}
      sections={PRIVACY_PAGE_CONTENT.sections}
      actions={[
        { label: PUBLIC_CORE_LINK_LABELS.gdpr, onPress: () => navigate('/gdpr'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.terms, onPress: () => navigate('/terms'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.contactSupport, onPress: () => navigate('/contact-complaints'), tone: 'outline' },
      ]}
    />
  );
}
